<h2 mat-dialog-title class="mat-dialog-title-offset">Submission History</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2 tw:flex tw:justify-center tw:items-center">

  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    <app-data-table
      [columns]="columns"
      [data]="rows"
      [pageSize]="5"
      emptyMessage="No submission history found">
    </app-data-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="div-flex-buttons">
  <div class="tw:pl-2">
    <div class="divclose">
      <button mat-dialog-close input type="button" [mat-dialog-close]="true" class="btn btn-primary">Close</button>
    </div>
  </div>
</mat-dialog-actions>